import { action, makeObservable, observable } from 'mobx';

class ConnectionPopupStore {
  isOpenPopup = false;

  popupName = '';

  constructor() {
    makeObservable(this, {
      popupName: observable,
      isOpenPopup: observable,
      open: action.bound,
      close: action.bound,
      setPopupName: action.bound,
      setIsOpenPopup: action.bound,
    });
  }

  setIsOpenPopup(bool) {
    this.isOpenPopup = bool;
  }

  setPopupName(name) {
    this.popupName = name;
  }

  open(name) {
    this.setIsOpenPopup(true);
    this.setPopupName(name);
  }

  close = () => {
    this.isOpenPopup = false;
    this.popupName = '';
  };
}

export const connectionPopupStore = new ConnectionPopupStore();
